"use client";

import Image from "next/image";
import Link from "next/link";
import { BlogPost } from "@/Types/responses/blog";

function formatDate(iso: string) {
    return new Date(iso).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

interface BlogCardProps {
    post: BlogPost;
    variant?: "standard" | "featured";
    priority?: boolean;
    className?: string;
}

export default function BlogCard({ post, variant = "standard", priority = false, className = "" }: BlogCardProps) {
    const isFeatured = variant === "featured";

    return (
        <Link
            href={`/blog/${post.postSlug}`}
            className={`group flex flex-col w-full overflow-hidden transition-all duration-200 ${className}`}
        >
            {/* Image */}
            <div
                className={`relative w-full overflow-hidden ${
                    isFeatured ? "h-72 md:h-80" : "h-64"
                }`}
            >
                {post.featuredImage ? (
                    <Image 
                        src={post.featuredImage}
                        alt={post.postTitle}
                        fill
                        sizes={
                            isFeatured
                                ? "(max-width: 768px) 100vw, 50vw"
                                : "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        }
                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                        priority={priority}
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200">
                        <span className="text-gray-400 text-sm">No image</span>
                    </div>
                )}

                {/* Featured badge */}
                {/* {post.isFeatured && (
                    <span className="absolute top-3 left-3 bg-redColor text-white text-xs font-semibold px-2 py-1 rounded-md">
                        Featured
                    </span>
                )} */}
            </div>

            {/* Content */}
            <div className="flex flex-col flex-1 p-2 gap-3">

                {/* Title */}
                <h2
                    className={` text-gray-900 leading-snug group-hover:underline underline-offset-1 transition-colors line-clamp-2 ${
                        isFeatured ? "text-sm md:text-xl" : "text-sm md:text-xl"
                    }`}
                >
                    {post.postTitle}
                </h2>

            </div>
        </Link>
    );
}